import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Amplify Configuration
import Auth from '@aws-amplify/auth';
// import Storage from '@aws-amplify/storage';
import AWSConfig from './aws-exports';
// Storage.configure(AWSConfig);
Auth.configure(AWSConfig);
// End Amplify Configuration



// Sentry.init({
//   dsn: 'https:aebeef2b000a4e658aecf82ec7d6f796@o464405.ingest.sentry.io/5472942',
//   integrations: [
//     new Integrations.BrowserTracing({
//       tracingOrigins: [/*'localhost:4200',*/ environment.sentritracingOrigins
//       ],
//       routingInstrumentation: Sentry.routingInstrumentation,

//     }),
//   ],


//   tracesSampleRate: 1.0,
// });

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));


  //hide all consoles
if (environment.hideConsole) {
  console.warn(`🚨 Console output is disabled on production!`);
  console.error = function (): void { };
  console.log = function (): void { };
  console.debug = function (): void { };
  console.warn = function (): void { };
  console.info = function (): void { };
}
  